import PropTypes from "prop-types";
import { ReactComponent as StarFillIcon } from '../../../../../../../../assets/icons/ic_star.svg';
import ImageHelper from "../../../../../../../../utilities/helpers/ImageHelper";
import moment from "moment";

const StarRating = ({ rating }) => {
    return (
        <div className="star-rating d-flex">
            <span className="review-rate">{parseFloat(rating).toFixed(1)}</span>
            <StarFillIcon width={12} height={12} style={{ color: '#22264C99', marginTop:1.5 }}/>
        </div>
    );
};

const displayDate = (date) => {
    return moment.unix(date).format('MMM D, YYYY, HH:mm');
}

const CustomerReviewItem = ({review}) => {
    return (
        <div className="customer-review-main review_section">
            <div className="d-flex justify-between">
                <div className="d-flex items-center">
                    <img
                        src={ImageHelper.getFullImageUrl(review?.experience.thumbnail_url)}
                        className="review-experince-image"
                    />
                    <div>
                        <h4 className="font-family-lato review_title truncate" title={review.experience.title}>{review.experience.title}</h4>
                        <h4 className="font-family-lato review_date">{displayDate(review.created_at)}</h4>
                    </div>
                </div>
                <div className="d-flex">
                    <StarRating rating={review.rating}/>
                </div>
            </div>
            <div className="review_descriptions" style={{marginTop: review.text ? 16 : 0}}>
                <h4 title={review.text}>{review.text}</h4>
            </div>
            {
                review.assets && review.assets.length > 0 ? (
                    <div className="review_image_wrappper">
                        {
                            review.assets?.map((image, index) => (
                                <img
                                    key={index}
                                    src={ImageHelper.getFullImageUrl(image)}
                                    className="review-image"
                                />
                            ))
                        }
                    </div>
                ) : null
            }
        </div>
    )   
}

CustomerReviewItem.propTypes = {
    review: PropTypes.object.isRequired
};

export default CustomerReviewItem;